import { render, staticRenderFns } from "./Campaign2024.vue?vue&type=template&id=3ce3c87a"
import script from "./Campaign2024.vue?vue&type=script&lang=js"
export * from "./Campaign2024.vue?vue&type=script&lang=js"
import style0 from "./Campaign2024.vue?vue&type=style&index=0&id=3ce3c87a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports